import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import { downloadFile } from "../../../utils/download-file";
import { EventBus } from "../../../event-bus";
import consts from "../../../_consts";
import * as frConsts from "./constants";
import * as storeUtils from "../../../utils/store-handler";
import { EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";

export const state = {
  files: [],
  pagination: {
    count: 10,
    total: 0
  },
  latestBiometricFile: [],
  latestEligibilityFile: [],
  latestIncentiveFile: [],
  uploadErrors: [],
  transactionStatusOnWait: null
};

export const getters = {
  [frConsts.GETTERS_FILES_PROCESSING_LIST]: state => {
    return state.files;
  },
  [frConsts.GETTERS_FILES_PROCESSING_PAGINATION]: state => {
    return state.pagination;
  },
  [frConsts.GETTERS_LATEST_ELIGIBILITY_FILE]: () => {
    return state.latestEligibilityFile;
  },
  [frConsts.GETTERS_LATEST_BIOMETRIC_FILE]: () => {
    return state.latestBiometricFile;
  },
  [frConsts.GETTERS_LATEST_INCENTIVE_FILE]: () => {
    return state.latestIncentiveFile;
  },
  [frConsts.GETTERS_FILE_PROCESSING_UPLOAD_ERROR]: () => {
    return state.uploadErrors;
  },
};

export const actions = {
  [frConsts.ACTION_GET_FILES_PROCESSING_LIST]: ({ commit }, options) => {
    makeCall(
      getEndPoints().files_processing.getList,
      buildOptions("GET", options),
      commit
    ).then(response => {
      if (response.data) {
        commit(frConsts.MUTATION_SET_FILES_PROCESSING_LIST, response);
      }
    });
  },
  [frConsts.ACTION_GET_LATEST_FILE]: ({ commit }, options) => {
    makeCall(
      getEndPoints().files_processing.getList,
      buildOptions("GET", options),
      commit
    ).then(response => {
      if (response.data && options.file_type !== "") {
        switch (options.file_type) {
          case consts.uploadFileType.eligibility:
            commit(frConsts.MUTATION_SET_LATEST_PROCESSING, {
              type: consts.uploadFileType.eligibility,
              data: response.data
            });
            break;
          case consts.uploadFileType.biometrics:
            commit(frConsts.MUTATION_SET_LATEST_PROCESSING, {
              type: consts.uploadFileType.biometrics,
              data: response.data
            });
            break;
          case consts.uploadFileType.incentive:
            commit(frConsts.MUTATION_SET_LATEST_PROCESSING, {
              type: consts.uploadFileType.incentive,
              data: response.data
            });
            break;
        }
      }
    });
  },
  [frConsts.ACTION_GET_FILE_PROCESSING_UPLOAD_ERROR]: (
    { dispatch, commit },
    transactionId
  ) => {
    commit(frConsts.MUTATION_SET_FILE_PROCESSING_UPLOAD_ERROR, {});
    const url = getEndPoints().files_processing.getFileUploadError.replace(
      ":transaction_id",
      transactionId
    );
    makeCall(url, buildOptions("GET", {}), commit).then(response => {
      if (response.data) {
        commit(frConsts.MUTATION_SET_FILE_PROCESSING_UPLOAD_ERROR, response);
      }
    });
  },
  [frConsts.ACTION_DOWNLOAD_FILE_UPLOAD]: ({ commit }, options) => {
    const url = getEndPoints()
      .files_processing.downloadFileUpload.replace(":file_id", options.file_id)
      .replace(":employer_id", options.employer_id);
    makeCall(url, buildOptions("GET", options), commit)
      .then(response => {
        if (response) {
          downloadFile(response, options.file_name);
        }
      })
      .catch(function(err) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          storeUtils.handleErrorMessage(err).message
        );
      });
  },
  [frConsts.ACTION_DOWNLOAD_ERROR_FILE_REVIEW]: ({ commit }, options) => {
    options.responseType = "stream";
    const url = getEndPoints()
      .files_processing.downloadErrorFileReview.replace(
        ":transaction_id",
        options.transaction_id
      )
      .replace(":code", options.code);
    makeCall(url, buildOptions("GET", options), commit)
      .then(response => {
        if (response) {
          downloadFile(response, options.file_name);
        }
      })
      .catch(function(err) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          storeUtils.handleErrorMessage(err).message
        );
      });
  },
};

export const mutations = {
  [frConsts.MUTATION_SET_FILES_PROCESSING_LIST]: (state, files) => {
    state.files = files.data;
    state.pagination = files.meta.pagination;
  },
  [frConsts.MUTATION_SET_LATEST_PROCESSING]: (state, params) => {
    switch (params.type) {
      case consts.uploadFileType.eligibility:
        state.latestEligibilityFile = params.data;
        break;
      case consts.uploadFileType.biometrics:
        state.latestBiometricFile = params.data;
        break;
      case consts.uploadFileType.incentive:
        state.latestIncentiveFile = params.data;
        break;
    }
  },
  [frConsts.MUTATION_SET_FILE_PROCESSING_UPLOAD_ERROR]: (state, errors) => {
    state.uploadErrors = errors.data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/files_processing/index.js